import { createFileRoute } from "@tanstack/react-router";
import { TransportPage } from "../../components/participant/transport-page";

/** `/me/transport` — every participant (athlete or not): the transfers they are booked on. The API reads only their own. */
export const Route = createFileRoute("/_app/me/transport")({
	component: TransportPage,
});
